import api from 'config/api';
import { Notification } from 'notification/notification';
import { logout } from './auth';

export const getInfoUser = async () => {
  try {
    const { data } = await api.get('account/v1/info');
    return data;
  } catch (err) {
    Notification(500);
  }
};

export const changePassword = async (values) => {
  try {
    const { status } = await api.post('auth/change-password', values);
    logout();
    return status;
  } catch (err) {
    Notification(500);
  }
};

export const getUserInfo = async () => {
  try {
    const { data } = await api.get('account/v1/info');
    return data;
  } catch (err) {
    Notification(500);
  }
};

export const setUserInfoSave = async (values) => {
  try {
    const { status } = await api.post('account/v1/info', values);
    return status;
  } catch (err) {
    Notification(500);
  }
};

export const getUserAll = async () => {
  try {
    const { data } = await api.get('account/v1/');
    return data;
  } catch (err) {
    Notification(500);
  }
};

export const setUserSave = async (values) => {
  try {
    return await api.post('account/v1/', values);
  } catch (err) {
    Notification(500);
  }
};

export const getUserById = async (id) => {
  try {
    const { data } = await api.get(`account/v1/${id}`);
    return data;
  } catch (err) {
    Notification(500);
  }
};

export const deleteById = async (id) => {
  try {
    const { status } = await api.delete(`account/v1/${id}`);
    return status;
  } catch (err) {
    Notification(500);
  }
};
